/* eslint "no-console": "off" */
import { captureMessage } from '@sentry/react';
import { format } from 'date-fns';
import { DEBUG, IS_TEST } from 'env';

import { getCurrentDate } from 'helpers/date';

class Logger {
    constructor() {
        this.timestamp = format(getCurrentDate(), 'dd/MM/yyyy hh:mm:ss');
    }

    error(msg) {
        captureMessage(msg);
        console.error(`[${this.timestamp}] ERROR: ${msg}`);
    }

    warn(msg) {
        console.warn(`[${this.timestamp}] WARN: ${msg}`);
    }

    info(msg) {
        console.info(`[${this.timestamp}] INFO: ${msg}`);
    }

    debug(msg) {
        if (DEBUG && !IS_TEST) {
            console.log(`[${this.timestamp}] DEBUG: ${msg}`);
        }
    }
}

export default new Logger();
